export const CABANG_GET_LIST_OUTLET_REQUEST = "CABANG_GET_LIST_OUTLET_REQUEST";
export const CABANG_GET_LIST_OUTLET_SUCCESS = "CABANG_GET_LIST_OUTLET_SUCCESS";
export const CABANG_GET_LIST_OUTLET_FAIL = "CABANG_GET_LIST_OUTLET_FAIL";
export const CABANG_GET_LIST_OUTLET_RESET = "CABANG_GET_LIST_OUTLET_RESET";
